import React, { useState, useRef } from "react";
import "./LandingPage.scss";
import CommonButton from "../../components/CommonButton/CommonButton";
import CommonText from "../../components/CommonText/CommonText";
import FileViewer from "../../components/CommonPreview/CommonPreview";
import { AiOutlinePaperClip } from "react-icons/ai";
import FileViewerObj from "../../components/CommonPreview/CommonPreviewObj";

interface Message {
  id: number;
  text?: string;
  type: "sent" | "received";
  date: string;
  time: string;
  fileUrl?: string;
}

const LandingPage: React.FC = () => {
  const [messages, setMessages] = useState<Message[]>([
  {
    id: 1,
    text: "Hello! 👋",
    type: "received",
    date: "22 Sep 2025",
    time: "10:15 AM",
  },
  {
    id: 2,
    text: "Hi, how are you?",
    type: "sent",
    date: "22 Sep 2025",
    time: "10:16 AM",
  },
  {
    id: 3,
    text: "Check this image:",
    type: "received",
    date: "22 Sep 2025",
    time: "10:17 AM",
    fileUrl: "https://firebasestorage.googleapis.com/v0/b/schoolone-firebase.firebasestorage.app/o/uploads%2F1742568087360_Schoolone.png?alt=media&token=3de272a9-b2a8-4833-8813-13ae6977ced9",
  },
  {
    id: 4,
    text: "Here's an image",
    type: "sent",
    date: "22 Sep 2025",
    time: "10:18 AM",
    fileUrl: "https://firebasestorage.googleapis.com/v0/b/schoolone-firebase.firebasestorage.app/o/uploads%2F1742569272459_Schoolone.png?alt=media&token=070c618b-a545-421e-9375-985192b4894b",
  }
]);


  const [text, setText] = useState<string>("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleSend = () => {
    if (!text.trim() && !selectedFile) return;

    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    const formattedTime = now.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    let fileUrl: string | undefined;
    if (selectedFile) {
      fileUrl = URL.createObjectURL(selectedFile);
    }

    const newMessage: Message = {
      id: Date.now(),
      text: text.trim() ? text : undefined,
      type: "sent",
      date: formattedDate,
      time: formattedTime,
      fileUrl,
    };

    setMessages((prev) => [...prev, newMessage]);
    setText("");
    setSelectedFile(null);
  };

  const groupMessagesByDate = (msgs: Message[]) => {
    return msgs.reduce((groups: Record<string, Message[]>, msg) => {
      if (!groups[msg.date]) groups[msg.date] = [];
      groups[msg.date].push(msg);
      return groups;
    }, {});
  };

  return (
    <div className="chat-container">
      <div className="chat-body">
        {Object.entries(groupMessagesByDate(messages)).map(([date, msgs]) => (
          <div key={date}>
            <div className="w-100">
              <div className="date-separator vertical-center common-size-12">
                {date}
              </div>
            </div>

            {msgs.map((msg, index) => {
              const showProfile =
                index === 0 || msgs[index - 1].type !== msg.type;
              const profileSrc =
                msg.type === "sent"
                  ? "/assets/images/default_profile.png"
                  : "https://i.pravatar.cc/50?img=28";

              return (
                <div key={msg.id} className={`chat-row ${msg.type}`}>
                  <div className="profile-wrapper">
                    {showProfile ? (
                      <img
                        src={profileSrc}
                        alt={msg.type}
                        className="profile-img"
                      />
                    ) : (
                      <div className="profile-placeholder" />
                    )}
                  </div>
                  <div className="chat-message">
                    {msg.text && <p>{msg.text}</p>}
                    {msg.fileUrl && <FileViewer fileUrl={msg.fileUrl} />}
                    <span className="chat-timestamp">{msg.time}</span>
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* Chat Footer */}
      <form
        className="chat-footer"
        onSubmit={(e) => {
          e.preventDefault();
          handleSend();
        }}
      >
        {/* Hidden file input */}
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={(e) => {
            if (e.target.files && e.target.files[0]) {
              setSelectedFile(e.target.files[0]);
            }
          }}
        />

        <CommonButton
          btnText=""
          onClick={() => fileInputRef.current?.click()}
          className="attachment-btn common-size-20"
          icon={AiOutlinePaperClip}
          height="30px"
          width="30px"
          border=""
          borderRadius="20px"
        />

        <CommonText
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Type a message"
          maxLength={200}
          backgroundColor="#FFF"
          border="1px solid #cbdcff"
          borderRadius="20px"
          className="chat-input"
        />

        <CommonButton
          btnText="Send"
          type="submit"
          onClick={() => {}}
          className="send-btn common-border"
          height="40px"
          border=""
          borderRadius="20px"
        />
      </form>

      {/* File preview before sending */}
      {selectedFile && (
        <div className="selected-file-preview p-2">
          <FileViewerObj fileObject={selectedFile} showDownloadButton={false} />
        </div>
      )}
    </div>
  );
};

export default LandingPage;
